import { createSlice } from "@reduxjs/toolkit";

const initialAddGameState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  appEventList: [],
  newGame: {},
  eventForEdit: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const AddEventsSlice = createSlice({
  name: "addEventsSlice",
  initialState: initialAddGameState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.featureImage = {};
      state.bannerImage = {};
      state.inGameNameImage = {};
      state.tournamentImage = {};
    },

    AppEventList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.appEventList = countryList;
    },

    createGame: (state, action) => {
      const { newGame } = action.payload;
      state.error = null;
      state.newGame = newGame;
    },
    singleItemFetched: (state, action) => {
      state.eventForEdit = action.payload.gameForEdit;
      state.error = null;
      state.actionsLoading = false;

      console.log(state.eventForEdit)
    },
  },
});
